export interface ProjectAIOrganizeResultSuggestionItem {
    id: string;
    type: "screen" | "variantGroup";
    new?: boolean;
}

export enum ProjectAIOrganizeResultStatus {
    IN_PROGRESS = "in_progress",
    PENDING = "pending",
    COMPLETED = "completed",
    FAILED = "failed",
    EXPIRED = "expired",
    REJECTED = "rejected"
}

export interface ProjectAIOrganizeResultSuggestionNewSection {
    id: string;
    name: string;
    description?: string;
    parent?: string;
    order?: string;
    index?: number;
    items?: ProjectAIOrganizeResultSuggestionItem[];
}

export interface ProjectAIOrganizeResultSuggestionUpdatedSection {
    id: string;
    name?: string;
    description?: string;
    parent?: string;
    order?: string;
    index?: number;
    items?: ProjectAIOrganizeResultSuggestionItem[];
}

export interface ProjectAIOrganizeResultSuggestionVariantGroupScreen {
    id: string;
    variantName: string;
}

export interface ProjectAIOrganizeResultSuggestionNewVariantGroup {
    id: string;
    name: string;
    screens: ProjectAIOrganizeResultSuggestionVariantGroupScreen[];
}

export type ProjectAIOrganizeResultSuggestionUpdatedVariantGroup = Omit<ProjectAIOrganizeResultSuggestionNewVariantGroup, "name">;

export interface ProjectAIOrganizeResultSuggestion {
    newSections: ProjectAIOrganizeResultSuggestionNewSection[];
    updatedSections: ProjectAIOrganizeResultSuggestionUpdatedSection[];
    newVariantGroups: ProjectAIOrganizeResultSuggestionNewVariantGroup[];
    updatedVariantGroups: ProjectAIOrganizeResultSuggestionUpdatedVariantGroup[];
}

export default interface ProjectAIOrganizeResult {
    _id?: string;
    status: ProjectAIOrganizeResultStatus;
    suggestions?: ProjectAIOrganizeResultSuggestion;
    requestedScreens: string[];
    requestedVariantGroups: string[];
}
